import { AbstractControl } from '@angular/forms';
import { BeneficiaryTypeEnum, BeneficiaryTypes } from '@pg-app/client/payment/constants/beneficiary-type-list';

export function numberOfWordBeneficiaryNameValidator(nameControl = 'recipientName', typeControl = 'beneType') {
    return (frm: AbstractControl) => {
        const beneficiaryName = frm.get(nameControl).value;
        const beneficiaryType = frm.get(typeControl).value;
        const individualTypeString = BeneficiaryTypes.find(p => p.id === BeneficiaryTypeEnum.Individual).name;

        if (!beneficiaryName
            || beneficiaryType === null
            || (beneficiaryType !== BeneficiaryTypeEnum.Individual
                && beneficiaryType !== individualTypeString)) {
            return null;
        }

        const numberOfWordBeneficiaryName = beneficiaryName.trim().split(' ').length;
        return numberOfWordBeneficiaryName >= 2
            ? null
            : {
                numberOfWordBeneficiaryName: true
            };
    };
}
